import { SetState } from 'zustand';

export interface IErrorSlice {
    serverError: string,
    setServerError: (content: string) => void;
    resetErrorSlice: () => void;
}

const createErrorSlice = (set: SetState<IErrorSlice>) => ({
  serverError: '',
  setServerError: (content: string) => {
    set({ serverError: content });
  },
  resetErrorSlice: () => {
    set({ serverError: '' });
  },
});

export default createErrorSlice;
